import angular from 'angular';

import component from './documentThumbnail.component';
import './documentThumbnail.css';

let module = angular.module('recaps.components.documentThumbnail', [
]);

module.component('documentThumbnail', component);

export default module;
